import {TASKMANAGE} from 'Constants/ActionTypes';

const {GET_TASK_FIRSTPAGE_LIST, GET_TASK_FIRSTPAGE_OUTSTATUS_LIST} = TASKMANAGE;
// 通用前缀
const url = '/robot';

const actions = {
  // 任务管理-首页-统计概况-列表
  getTaskFirstPageList(data) {
    return {
      type: GET_TASK_FIRSTPAGE_LIST,
      payload: {
        request: {
          method: 'post',
          url: `${url}/task/xy/statistic`,
          data,
        },
      },
    };
  },

  getTaskFirstPageOutStatusList(data) {
    return {
      type: GET_TASK_FIRSTPAGE_OUTSTATUS_LIST,
      payload: {
        request: {
          method: 'post',
          url: `${url}/task/xy/statistic2`,
          data,
        },
      },
    };
  },
};
export default actions;
